import React, { useState, useEffect, useContext } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "../../Components/HomePage/Navbar/Navbar";
import Footer from "../../Components/HomePage/Footer/Footer";
import Intro from "../../Components/HomePage/Intro/Intro";
import Services from "../../Components/HomePage/Services/Services";
import About from "../../Components/HomePage/About/About";
import Overview from "../../Components/HomePage/Overview/Overview";
import Process from "../../Components/HomePage/Process/Process";
import Features from "../../Components/HomePage/Features/Features";
import Pricing from "../../Components/HomePage/Pricing/Pricing";
import "./LandingPage.css";
import "aos/dist/aos.css"; // Import AOS styles
import AOS from "aos"; // Import AOS library
import { ThemeContext } from "../../context/ThemeContext";

const LandingPage = () => {
  const [scrolled, setScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState("home");
  const { darkMode } = useContext(ThemeContext);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 80) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }

      const sections = ["home", "about", "services", "pricing"];
      const currentPosition = window.scrollY + 300;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (
            currentPosition >= offsetTop &&
            currentPosition < offsetTop + offsetHeight
          ) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    // Only add scroll listener if we're on the landing page
    if (location.pathname === "/") {
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    }
  }, [location]);

  // Initialize AOS
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: false,
      mirror: true,
    });
  }, []);

  // Smooth scroll function
  const handleNavClick = (e, targetId) => {
    e.preventDefault();
    const targetSection = document.getElementById(targetId);
    if (targetSection) {
      const offsetTop =
        targetSection.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: offsetTop,
        behavior: "smooth",
      });
    }
  };

  // Only render landing page content if we're on the root path
  if (location.pathname !== "/") {
    return null;
  }

  return (
    <div className={`landing-container ${darkMode ? "dark-mode" : ""}`}>
      <Navbar
        scrolled={scrolled}
        activeSection={activeSection}
        handleNavClick={handleNavClick}
      />
      <main>
        <section id="home">
          <Intro />
        </section>
        <section id="services">
          <Services />
        </section>
        <section id="about">
          <About />
        </section>
        <Overview />
        <Features />
        <Process />
        <section id="pricing">
          <Pricing />
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
